export const getActionColor = action => {
  switch (action) {
    case 'cta': return 'blue'
    case 'error': return 'orange'
    default: return 'default'
  }
}
